export default __webpack_public_path__ + "static/media/fundo.2e406714.svg";